module.exports = __webpack_public_path__ + "img/passport_placeholder.4a295a66.png";